/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.circle-plus\":\"Ympyrä ja plusmerkki\"}");